import type { SVGProps } from 'react';

type IconName =
  | 'home'
  | 'calendar'
  | 'check-square'
  | 'users'
  | 'user'
  | 'user-plus'
  | 'building'
  | 'layers'
  | 'list'
  | 'bar-chart'
  | 'settings'
  | 'logout'
  | 'menu'
  | 'x'
  | 'print'
  | 'pill'
  | 'phone'
  | 'video'
  | 'bell'
  | 'home-heart'
  | 'key';

const PATHS: Record<IconName, React.ReactNode> = {
  home: <path d="M3 12L12 4l9 8M5 10v10h14V10" />,
  calendar: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 9h18M8 3v4M16 3v4" />
    </>
  ),
  'check-square': (
    <>
      <rect x="3" y="3" width="18" height="18" rx="3" />
      <path d="M8 12l3 3 5-6" />
    </>
  ),
  users: (
    <>
      <path d="M16 11a3 3 0 100-6 3 3 0 000 6zM8 11a3 3 0 100-6 3 3 0 000 6z" />
      <path d="M3 20c0-2.5 2.5-4 5-4s5 1.5 5 4M13 20c0-2.5 2.5-4 5-4s5 1.5 5 4" />
    </>
  ),
  user: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c0-4 4-7 8-7s8 3 8 7" />
    </>
  ),
  'user-plus': (
    <>
      <circle cx="9" cy="8" r="4" />
      <path d="M3 21c0-4 3-7 6-7s6 3 6 7M17 8h6M20 5v6" />
    </>
  ),
  building: (
    <>
      <rect x="4" y="3" width="16" height="18" rx="1.5" />
      <path d="M9 7h.01M15 7h.01M9 11h.01M15 11h.01M9 15h.01M15 15h.01M10 21v-3h4v3" />
    </>
  ),
  layers: <path d="M12 3l9 5-9 5-9-5 9-5zm0 8l9 5-9 5-9-5 9-5z" />,
  list: <path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" />,
  'bar-chart': <path d="M3 21V8m6 13V4m6 17v-9m6 9V12" />,
  settings: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09a1.65 1.65 0 00-1-1.51 1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09a1.65 1.65 0 001.51-1 1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" />
    </>
  ),
  logout: <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />,
  menu: <path d="M4 6h16M4 12h16M4 18h16" />,
  x: <path d="M18 6L6 18M6 6l12 12" />,
  print: (
    <>
      <path d="M6 9V2h12v7M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2M6 14h12v8H6z" />
    </>
  ),
  pill: <path d="M10.5 20.5L20 11a4.95 4.95 0 00-7-7l-9.5 9.5a4.95 4.95 0 007 7zM8.5 8.5l7 7" />,
  phone: <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.13.95.36 1.88.7 2.78a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.3-1.3a2 2 0 012.11-.45c.9.34 1.83.57 2.78.7a2 2 0 011.72 2z" />,
  video: (
    <>
      <rect x="2" y="6" width="14" height="12" rx="2" />
      <path d="M22 7l-6 5 6 5V7z" />
    </>
  ),
  'home-heart': <path d="M3 12L12 4l9 8M5 10v10h14V10M9.5 14.5a1.5 1.5 0 012.5-1.06A1.5 1.5 0 0114.5 14.5c0 1.5-2.5 3.5-2.5 3.5s-2.5-2-2.5-3.5z" />,
  'key': <path d="M21 2l-9.5 9.5M15.5 7.5L19 11M9 14a4 4 0 11-4 4 4 4 0 014-4z" />,
  bell: <path d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 01-3.4 0" />,
};

interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName;
  size?: number;
}

export function Icon({ name, size = 16, ...rest }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      {PATHS[name]}
    </svg>
  );
}

export type { IconName };
